@if (vm$ | async; as vm) {
  <div class="vaelg-installation__box">
    @if (vm.vaelgInstallationHref) {
      <a
        class="vaelg-installation__info"
        role="link"
        [attr.title]="'Måler: ' + vm.maalerNr"
        [href]="vm.vaelgInstallationHref"
        (click)="onLinkClick($event, vm.vaelgInstallationHref)"
      >
        <span class="vaelg-installation__adresse">{{ vm.adresse }}</span>
        @if (vm.maalerNr) {
          <small class="vaelg-installation__maaler">Måler: {{ vm.maalerNr }}</small>
        }
        @if (vm.adresse && !vm.maalerNr) {
          <small class="vaelg-installation__maaler">Status: Passiv</small>
        }
      </a>
    } @else {
      <div class="vaelg-installation__info">
        <span class="vaelg-installation__adresse">{{ vm.adresse }}</span>
        @if (vm.maalerNr) {
          <small class="vaelg-installation__maaler">Måler: {{ vm.maalerNr }}</small>
        }
        @if (vm.adresse && !vm.maalerNr) {
          <small class="vaelg-installation__maaler">Status: Passiv</small>
        }
      </div>
    }
    @if (showNotificationTrigger$ | async) {
      <eforsyning-notification-dialog-trigger class="vaelg-installation__notifications"></eforsyning-notification-dialog-trigger>
    }
    @if (vm.vaelgInstallationHref) {
      <a
        class="vaelg-installation__skift"
        [href]="vm.vaelgInstallationHref"
        (click)="onLinkClick($event, vm.vaelgInstallationHref)"
      >SKIFT...</a>
    }
  </div>
}
